import {ChangeDetectionStrategy, Component, ElementRef, forwardRef, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {createDisplaySymbol, DisplaySymbol} from '../../common/display-symbol';
import {Security} from '../../models/security';
import {AutocompleteInputComponent} from '../autocomplete-input';
import {SecurityAutocompleteDirective} from '../security-autocomplete';

@Component({
    selector: 'security-input',
    templateUrl: './security-input.component.html',
    styleUrls: ['./security-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SecurityInputComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecurityInputComponent extends AutocompleteInputComponent<Security> {

    @ViewChild(SecurityAutocompleteDirective, {static: true})
    public override innerValueAccessor: SecurityAutocompleteDirective;

    @ViewChild(SecurityAutocompleteDirective, {read: ElementRef, static: true})
    public override innerInputElementRef: ElementRef;

    public displaySymbol: DisplaySymbol;

    public override writeValue(security: Security): void {
        super.writeValue(security);

        this.updateDisplaySymbol();
    }

    protected override innerPropagateOnChange(security: Security): void {
        super.innerPropagateOnChange(security);

        this.updateDisplaySymbol();
    }

    private updateDisplaySymbol(): void {
        this.displaySymbol = this.value && createDisplaySymbol(this.value);
    }

}
